import { customProviderItemsFilter } from '../data';

export const initialState = {
  actionProcessing: false,
  providers: {
    items: [],
    count: 0,
  },
  games: [],
  previousProviders: {
    items: [],
  },
  previousGames: [],
  requests: {
    items: [],
    count: 0,
  },
  notifyRequests: {
    items: [],
    count: 0,
  },
  socialMedia: {
    telegram: '',
    instagram: '',
    facebook: '',
  },

  detailsData: {
    meta: null,
    games: [],
    providers: [],
    socialMedia: null,
    notifications: '',
    type: '',
  },
  singleRequest: null,
};
